import * as React from 'react';

function Instagram(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.194 3.947c-2.34 0-4.244 1.843-4.244 4.109v7.888c0 2.266 1.904 4.109 4.244 4.109h7.613c2.34 0 4.243-1.843 4.243-4.11V8.057c0-2.266-1.903-4.109-4.243-4.109H8.194zM15.807 21H8.193C5.33 21 3 18.732 3 15.944V8.056C3 5.268 5.329 3 8.193 3h7.614C18.671 3 21 5.268 21 8.056v7.888C21 18.732 18.67 21 15.807 21z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.91 8.656a3.14 3.14 0 00-2.196.901 3.382 3.382 0 00-1.024 2.415 3.324 3.324 0 003.325 3.316c1.823 0 3.284-1.46 3.325-3.326.043-2.007-1.204-3.242-3.339-3.305h-.092zm.104 7.58a4.274 4.274 0 01-4.274-4.264 4.33 4.33 0 011.312-3.095A4.166 4.166 0 0112.03 7.71c2.643.078 4.316 1.754 4.26 4.272v.002c-.052 2.383-1.93 4.251-4.275 4.251zM18.191 6.79a.948.948 0 01-.95.947.948.948 0 110-1.895c.525 0 .95.424.95.947z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Instagram;
